import { headers } from './constants';
import axios from 'axios';
import { SCENARIO_BASE_URL } from 'constants/api';
import queryString from 'query-string';

export const scenarioThreeAPI = {
    fetchVcData: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/vc-and-stats?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchTrendData: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/trend?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchOutliersData: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/outliers?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchDetailedViewData: (data) => {
        const { payload, params } = data;
        return axios
            .post(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/detailed-view?${queryString.stringify(params.requestParams)}`,
                payload,
                {
                    headers
                }
            )
            .then((response) => response.data);
    }
};
